
import React from 'react';
import './styledsk.css';
import logo from '../../assets/img/Sobr.png';
import arrow from '../../assets/img/arrow.svg';
import africangirl from '../../assets/teamsobr/africangirl.png'
import google from '../../assets/img/boton google play.svg';
import malte from '../../assets/img/maltefoto.jpg'
import ricardo from '../../assets/img/ricardofoto.jpg'
import koch from '../../assets/img/kochfoto.jpg'
import digao from '../../assets/img/digaofoto.jpg'
import felipe from '../../assets/img/felipefoto.jpg'
import erico from '../../assets/img/erikofoto.jpg'



const Home = () => {

    const scrollToMenu = () => {
        const menuElement = document.querySelector('.logo2');
        if (menuElement) {
            menuElement.scrollIntoView({ behavior: 'smooth' });
        }
    };
    return (
    <>
    <header className="header-containerx">
    <div className="header-left">
                <img className='logo2'src={logo} alt="Logo" height='70px' />
            </div>
            <nav className="header-nav">
            <a href="/br">Home</a>
                <a href="/embaixadores">Embaixadores</a>
                <a href="/timesobr">Time Sobr</a>
                <a href="/termosepolitica">Termos e Políticas</a>
            </nav>
            <div className="header-right">
            <a className='butontranslate' href="/">en-US</a>
            <a className='butontranslate' href="/es">es-ES</a>
            </div>
        </header>

        <body>

                <div className="iphone3">
                    <main>
                    <section className="hero5">
                    <h1>Bem-vindo à Sobr, onde a jornada para a felicidade é vibrante e encorajadora.</h1>
                    <p> Somos muito mais do que um aplicativo de relacionamento - somos uma comunidade dedicada a redefinir o conceito de felicidade, colocando a sobriedade no centro de tudo que fazemos.
                    </p>             
                    <button className="demo-button">BAIXE AGORA</button>
                    </section>
                    </main>
                </div>


                <div className="content12dsk">
                    <img className='like2' src={africangirl} alt="like" title="like" height="500" />  
                    <section>       
                    <p>Na Sobr, acreditamos que a verdadeira felicidade não é apenas possível, mas alcançável para todos. Nossa missão é proporcionar um espaço acolhedor e empoderador para aqueles que optam por viver uma vida sóbria, celebrando cada momento de alegria, cada conquista e cada passo em direção ao crescimento pessoal.</p>
        <p>Nosso compromisso com a autenticidade, saúde e relacionamentos sóbrios genuínos é o que nos impulsiona a cada dia. Aqui, você encontrará uma comunidade vibrante de pessoas com mentalidade semelhante, prontas para se apoiarem, se inspirarem e se capacitarem mutuamente em suas jornadas de sobriedade.        </p>
        <p>Então, se você está pronto para embarcar em uma jornada de autoconhecimento, conexão significativa e alegria autêntica, você veio ao lugar certo. Junte-se a nós na Sobr e vamos revolucionar a felicidade juntos.</p>                                   
                    </section>  
                </div>
                <div className='downloaddsk'>
                    <h3> Baixe o APP agora! </h3>
                <img className="google3" src={google} alt="Google play" title="Google play" height="38" width="140" />
                </div>
                <div className="content7dsk">
                    <h1>Seja bem-vindo à nossa comunidade. Seja bem-vindo à Sobr.</h1>
                </div>
                {/* <div className='reviewsdsk'>
                <div className="review-boxdsk">
                    <div className="header2dsk">
                        <h3>Margie V.</h3>
                        <p>Montevideo</p>
                    </div>
                    <div className="starxdsk">
                        <span className="star">&#9733;</span>
                        <span className="star">&#9733;</span>
                        <span className="star">&#9733;</span>
                        <span className="star">&#9733;</span>
                        <span className="star">&#9733;</span>
                        <span className="time">2 months ago</span>
                    </div>
                    <div className="contentdsk">
                        <p>This mobile application, known as Sobr, and any and all corresponding websites (collectively referred to as the "App") are operated by Sobr</p>
                    </div>
                    <div className="verifieddsk">
                        <span>Verified by</span>
                    </div>
                </div>
                <div className="review-boxdsk">
                    <div className="header2dsk">
                        <h3>Margie V.</h3>
                        <p>Montevideo</p>
                    </div>
                    <div className="starxdsk">
                        <span className="star">&#9733;</span>
                        <span className="star">&#9733;</span>
                        <span className="star">&#9733;</span>
                        <span className="star">&#9733;</span>
                        <span className="star">&#9733;</span>
                        <span className="time">2 months ago</span>
                    </div>
                    <div className="contentdsk">
                        <p>This mobile application, known as Sobr, and any and all corresponding websites (collectively referred to as the "App") are operated by Sobr</p>
                    </div>
                    <div className="verifieddsk">
                        <span>Verified by</span>
                    </div>
                </div>
                <div className="review-boxdsk">
                    <div className="header2dsk">
                        <h3>Margie V.</h3>
                        <p>Montevideo</p>
                    </div>
                    <div className="starxdsk">
                        <span className="star">&#9733;</span>
                        <span className="star">&#9733;</span>
                        <span className="star">&#9733;</span>
                        <span className="star">&#9733;</span>
                        <span className="star">&#9733;</span>
                        <span className="time">2 months ago</span>
                    </div>
                    <div className="contentdsk">
                        <p>This mobile application, known as Sobr, and any and all corresponding websites (collectively referred to as the "App") are operated by Sobr</p>
                    </div>
                    <div className="verifieddsk">
                        <span>Verified by</span>
                    </div>
                </div>
                </div> */}

<div className="team-container">
    
<div className="team-card">
        <div className="profile-image-container">
          <img src={digao} alt="Rodrigo" className="profile-image" />
        </div>
        <div className="team-info">
          <h2 className="team-name">Rodrigo Oliveira</h2>
          <h3 className="team-title">Co-Fundador e Diretor Comercial</h3>
          <p className="team-description">
          Já atuou em empresas como Panasonic do Brasil, Stanley’s Care, entre outras...
          </p>
        </div>
      </div>

      <div className="team-card">
        <div className="profile-image-container">
          <img src={felipe} alt="Felipe" className="profile-image" />
        </div>
        <div className="team-info">
          <h2 className="team-name">Felipe Alarcon</h2>
          <h3 className="team-title">Co-Fundador e CEO</h3>
          <p className="team-description">
          Já foi gerente de operações da BITNATION, ganhadora do Gran Prix da UNESCO e gerente de produtos da CryptoMarket.
          </p>
        </div>
      </div>

      <div className="team-card">
        <div className="profile-image-container">
          <img src={koch} alt="Koch" className="profile-image" />
        </div>
        <div className="team-info">
          <h2 className="team-name">Marcus Koch</h2>
          <h3 className="team-title">CMO</h3>
          <p className="team-description">
            Contribuiu para marcas como Petrobras, Ponto Frio, Grupo Pão de Açúcar entre outras.
          </p>
        </div>
      </div>
      <div className="team-card">
        <div className="profile-image-container">
          <img src={erico} alt="Érico Ramos" className="profile-image" />
        </div>
        <div className="team-info">
          <h2 className="team-name">Érico Ramos</h2>
          <h3 className="team-title">Sócio Minoritário</h3>
          <p className="team-description">
            Atuou como consultor na Accenture, Google e Nokia.
          </p>
        </div>
      </div>

      <div className="team-card">
        <div className="profile-image-container">
          <img src={malte} alt="Malte Niebelschuetz" className="profile-image" />
        </div>
        <div className="team-info">
          <h2 className="team-name">Malte Niebelschuetz</h2>
          <h3 className="team-title">Diretor comercial - EUA</h3>
          <p className="team-description">
            Trabalhou como gestor de projetos na Deutsche Telekom e hoje possui negócios em San Diego.
          </p>
        </div>
      </div>

      <div className="team-card">
        <div className="profile-image-container">
          <img src={ricardo} alt="Ricardo Aquino" className="profile-image" />
        </div>
        <div className="team-info">
          <h2 className="team-name">Ricardo Aquino</h2>
          <h3 className="team-title">CMO</h3>
          <p className="team-description">
            Contribuiu para marcas como Petrobras, Ponto Frio, Grupo Pão de Açúcar entre outras.
          </p>
        </div>
      </div>

    </div>







                <footer>
                    <div className="footer-contentdsk">
                        <p>Termos de Serviço | Política de Privacidade</p>
                    </div>
                    <div className="footer-copyrightdsk">
                    &copy; 2024 Sobr Inc., Todos os Direitos Reservados   
                    </div>
                    {/* Ícone da seta para rolar até o menu principal */}
                    <div onClick={scrollToMenu} style={{ cursor: 'pointer', marginTop: '20px' }}>
                        <img src={arrow} height="24" width="24" alt="scroll to top" title="scroll to top" />
                    </div>
                </footer>

        </body>     
    </>
        );
    };
export default Home;
